export  const StringSplitConstant = {
    SPLIT_CHARACTER: "{end}"
}